import createBreakpoint from 'shared-tokens/utils/breakpoints';

const brpS = createBreakpoint('s');

export const mainCls = 'csa-login-presentation';

export default {
  [mainCls]: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 5,
    width: '100%',
    height: '100%',
    transform: 'translateX(100%)',
    '&._up': {
      transform: 'translateX(0)',
    }
  },
  [`${mainCls}__tit`]: {    
    fontSize: 20,
    lineHeight: '24px', 
    [brpS]: {
      paddingBottom: '8px !important',
    }
  },
  [`${mainCls}__item`]: {
    padding: '6px 0',
  },
  [`${mainCls}__icon`]: {
    width: 48,
    height: 48,
  },
  [`${mainCls}__txt`]: {
    lineHeight: '24px',
  },
};